import { TGetRecentVIPsResponseDTO } from "@/app/api/users/users.dto";
import { BASE_URL } from "@/lib/constants";
import { useQuery } from "@tanstack/react-query";
import Skeleton from "react-loading-skeleton";
import PeopleTile from "../components/people-tile";
import { usePathname } from "next/navigation";
import { useCountryContext } from "@/providers/country-provider";

const fetchPeople = async () => {
	try {
		const url = new URL(`${BASE_URL}/api/users`);
		url.searchParams.set("query", "recent-vips");

		const response = await fetch(url);
		const { data } = (await response.json()) as { data: TGetRecentVIPsResponseDTO };

		return data;
	} catch (error) {
		return [];
	}
};

const PeopleList = () => {
	const { isLoading, isError, data } = useQuery({
		queryKey: ["people"],
		queryFn: fetchPeople,
		refetchOnWindowFocus: false,
	});

	const pathname = usePathname();
	const { portals, popularTabs } = useCountryContext();
	const isCountryPortalPage = pathname === portals.current.href;

	const people = isCountryPortalPage ? popularTabs?.people ?? data : data;

	return isLoading ? (
		<Skeleton className="mt-8 h-24 space-x-6 rounded-xl" count={1} />
	) : isError ? (
		<span>Something went wrong</span>
	) : (
		<div className="mx-auto mt-8 flex w-full max-w-6xl flex-wrap justify-center gap-4 sm:mt-12">
			{people?.map((people, index) => (
				<PeopleTile key={index} {...people} />
			))}
		</div>
	);
};

export default PeopleList;
